/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import { Store } from 'vuex';

import { createRoutes } from './routes';

Vue.use(VueRouter);

export function createRouter() {
  return new VueRouter({
    mode: 'history',
  });
}

export function addRoutes(router: VueRouter, store: Store<any>) {
  router.addRoutes(createRoutes(store));
}

export function registerNavigationGuards(router: VueRouter, store: Store<any>) {
  router.beforeEach((_to: Route, _: Route, next: () => void) => {
    if (!store.state.initialized) {
      store.dispatch('initialize').then(next);
    } else {
      next();
    }
  });
}
